























































































































































































































































  import Vue from 'vue'
  import { Asset, AssetType, VideoAsset, TweetAsset, TweetPollAsset } from '@/types/assets'
  import StarRating from 'vue-star-rating'
  import { Stream } from '@/types/streams'
  import AssetPreview from '../AssetPreview'
  import InstagramPreview from '../InstagramPreview'
  import { Drag } from 'vue-drag-drop'
  import moment from 'moment'
  import './SingleFile.scss'
  import { cloneDeep } from 'lodash'
  import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
  import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
  import LiveChatPreview from '@/components/FileExplorer/FileSpace/LiveChatPreview/LiveChatPreview.vue'

  export default Vue.extend({
  name: 'SingleFile',
  props: {
    inCast: {
      type: Boolean,
      default: false
    },
    folderId: {
      type: String,
      required: true
    },
    assetId: {
      type: String,
      required: true
    },
    stream: {
      type: Object as () => Stream,
      required: false,
      default: null
    }
  },
  computed: {
    canRetranscode (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    isVideoAndHasError (): boolean {
      if (this.asset === null) return false
      if (this.asset.type !== AssetType.Video) return false
      const videoasset = this.asset as VideoAsset
      return videoasset.state === 'error'
    },
    canEditClips (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.Clip)
    },
    canDragFile (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.Asset)
    },
    canDelete (): boolean {
      return this.$can(AbilityAction.Delete, AbilitySubject.AssetGroups)
    },
    playListVideoIds (): string[] {
      return this.$store.direct.getters.events.playListVideoIds
    },
    assetDragData (): { asset: any } {
      const asset = cloneDeep(this.asset)
      if (asset && asset.type === AssetType.Broadcast && asset.id.indexOf('_lowrate') > -1) {
        asset.id = asset.id.split('_lowrate')[0]
      }
      return { asset: asset }
    },
    asset (): Asset|Stream|null {
      if (this.isStream) {
        return this.stream
      }
      const assetdb = this.assetdb
      if (!assetdb || Object.keys(assetdb).length === 0) {
        return null
      }
      return assetdb
    },
    pubDate (): string {
      if (this.asset && this.asset.hasOwnProperty('timestamp')) {
        const casset = this.asset as Asset
        if (casset.timestamp) {
          return moment.unix(casset.timestamp / 1000).format('hh:mm:ss a')
        }
      }
      return ''
    },
    displayableTwitterName (): string {
      if (!this.asset || !(this.asset as Asset).data) {
        return ''
      }
      const maxLength = 25
      if (this.asset.type === AssetType.Tweet) {
        const asset = this.asset as TweetAsset
        if (!asset.data?.user?.name) {
          return ''
        }
        if (asset.data?.user?.name?.length < maxLength) {
          return asset.data!.user.name
        }
        return asset.data?.user?.name?.substr(0, maxLength) + '...'
      }
      return ''
    },
    twitterQuestion (): string {
      if (this.asset && this.asset.type === AssetType.TweetPoll) {
        const asset = this.asset as TweetPollAsset
        return asset.question ? asset.question : 'Question is loading ...'
      }
      return ''
    }
  },
  data: () => ({
    showOverlay: false,
    areYouSure: false,
    dragging: false,
    assetdb: undefined as Asset | undefined,
    isStream: false,
    splitTweetText: {
      prepend: '',
      selected: '',
      append: ''
    }
  }),
  mounted () {
    this.assetdb = this.$store.direct.state.assets.assetGroupAssets[this.folderId][this.assetId]
    this.isStream = this.$store.direct.state.assets.assetGroupAssets[this.folderId] === undefined
  },
  watch: {
    'asset.data.selectedText' (newVal) {
      const asset: Asset = this.asset as Asset
      const split: string[] = asset.data.text.split(newVal)

      this.splitTweetText.prepend = split[0]
      this.splitTweetText.selected = newVal
      this.splitTweetText.append = split[1]
    }
  },
  methods: {
    isTweet (asset: Asset): boolean {
      return asset.type === AssetType.Tweet
    },
    isTwitterpoll (asset: Asset): boolean {
      return asset.type === AssetType.TweetPoll
    },
    isLiveChat (asset: Asset): boolean {
      return !!asset && (asset.type === AssetType.YouTubeChat || asset.type === AssetType.FacebookChat)
    },
    setRating (rating: number): void {
      this.$store.direct.dispatch.assets.updateAssetStars({ id: this.assetId, stars: rating })
    },
    deleteAsset (): void {
      console.log('deleteAsset ', this.asset)
      if (!this.asset) {
        return
      }
      const casset = this.asset as Asset
      const showMessage = ![AssetType.Tweet, AssetType.TweetPoll, AssetType.Instagram].includes(casset.type)
      //asset.name is always undefined for YouTube Chat assets, since it isn't included in the DB, so assigning fallbacks below
      const assetName = this.asset.name ?? (casset.type === AssetType.YouTubeChat ? 'YouTube message' : 'Asset')
      this.$store.direct.dispatch.assets.deleteAsset(this.assetId).then(() => {
        if (showMessage) {
          this.$message({
            type: 'success',
            message: `${assetName} has been deleted`
          })
        }
      }).catch(error => {
        this.$message({
          type: 'error',
          message: `Could not delete ${assetName}`
        })
        console.error('Delete asset in SingleFile error ', error)
      })
    },
    showDetails (): void {
      this.$emit('showDetails', this.assetId)
    },
    answersHtml (): string {
      if (!this.asset) {
        return ''
      }
      if (this.asset.type !== AssetType.TweetPoll) {
        return ''
      }
      const asset = this.asset as TweetPollAsset
      if (!asset.answers) {
        return ''
      }
      const colors = ['#397BCE', '#03AEEF', '#D69D36', '#4D4D4D', '#EEEEEE']
      let colorindex = 0
      let output = '<table width="100%">'
      asset.answers.forEach(answer => {
        output += `<tr><td width="50%">${answer.answer}</td>`
        output += `<td width="20%">${answer.percent}%</td>`
        output += `<td width="30%">`
        output += `<div style="background-color: ${colors[colorindex]};
                   width: ${answer.percent}%; border-radius: 3px">&nbsp;</div></td>`
        output += '</tr>'
        colorindex++
      })
      output += '</table>'
      output += `Total votes: ${asset.num_votes}  (${asset.timeleft})`
      if (asset.up_to_date === false && asset.timeleft !== 'Final results') {
        output += ' <font color="orange">Results are not up to date until the poll has ended</font>'
      }
      return output
    },
    isUploadableClip (): boolean {
      if (this.asset === null) return false
      if (this.asset.type !== AssetType.Video) return false
      const videoasset = this.asset as VideoAsset
      if (videoasset.state !== 'done') return false
      if (this.playListVideoIds.includes(this.asset.id)) return false
      return true
    },
    putClipInPlaylist (): boolean {
      if (this.asset === null) return false
      if (this.asset.id === undefined) return false
      this.$store.direct.dispatch.events.addClipToScenes({ assetId: this.asset.id, name: this.asset.name })
      this.$message({ type: 'success', message: 'Clip added to queue.'})
      return true
    },
    retranscodeAsset () {
      if (this.asset === null) return
      if (this.asset.id === undefined) return
      this.$store.direct.dispatch.assets.retranscodeClip(this.asset.id)
    }
  },
  components: {
    StarRating,
    AssetPreview,
    InstagramPreview,
    LiveChatPreview,
    Drag,
    ClipLoader,
  }
})
